import styled from 'styled-components';

export const NavigationBar = styled.div`
	width: 100%;
	max-width: 768px;
	padding: 8px 66px 15px 66px;
	box-shadow: 0px 0px 25px 0px rgba(30, 15, 5, 0.1);

	display: flex;
	justify-content: space-between;
	align-items: center;

	background-color: white;
`;

export const NavigationBarItem = styled.div<{ isHighlight: boolean }>`
	width: 50px;
	height: 50px;
	padding: 2px 9px 4px 9px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;

	svg {
		width: 32px;
		height: 32px;
		flex-shrink: 0;
		path {
			fill: ${({ theme, isHighlight }) =>
				isHighlight ? theme['orange-primary'] : theme['warmgray-300']};
		}
	}

	span {
		flex-shrink: 0;
	}
`;

export const NavigationIconItem = styled.div`
	width: 52px;
	height: 52px;
	flex-shrink: 0;

	position: absolute;
	top: -26px;
	right: calc(50% - 26px);

	filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
`;
